import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "No gateway created yet", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClusterOutlined = _resolveComponent("ClusterOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_peripherals_table = _resolveComponent("peripherals-table")!
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_create_gateway_modal = _resolveComponent("create-gateway-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_table, {
      columns: _ctx.columns,
      "data-source": _ctx.gateways,
      pagination: false,
      loading: _ctx.isLoading,
      "expanded-row-keys": _ctx.expandedRows,
      rowKey: "serialNumber",
      scroll: {
      x: 600,
    },
      class: "gateways-table"
    }, {
      expandIcon: _withCtx(({ expandable, expanded, record }) => [
        _createVNode(_component_a_button, {
          class: _normalizeClass(["expand-row-button", { 'pulsation-button': !expanded && !_ctx.rowHasBeenExpanded }]),
          type: "primary",
          shape: "circle",
          onClick: ($event: any) => (_ctx.toggleRow(expandable, expanded, record))
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_ClusterOutlined)
          ]),
          _: 2
        }, 1032, ["class", "onClick"])
      ]),
      expandedRowRender: _withCtx(({ record }) => [
        _createVNode(_component_peripherals_table, {
          gatewayId: record._id,
          peripherals: record.peripherals,
          onRefresh: _ctx.refreshGateways
        }, null, 8, ["gatewayId", "peripherals", "onRefresh"])
      ]),
      headerCell: _withCtx(({ column }) => [
        (column.key === 'actions')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_a_button, {
                type: "primary",
                shape: "circle",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createGatewayModalVisibility = true)),
                class: "create-gateway-button"
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_PlusOutlined)
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(column.title), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      bodyCell: _withCtx(({ column, record }) => [
        (column.key === 'actions')
          ? (_openBlock(), _createBlock(_component_a_popconfirm, {
              key: 0,
              title: "Are you sure you want to delete this gateway?",
              okType: "danger",
              onConfirm: ($event: any) => (_ctx.onDeleteGateway(record))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "danger",
                  shape: "circle"
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_DeleteOutlined)
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onConfirm"]))
          : _createCommentVNode("", true)
      ]),
      emptyText: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.createGatewayModalVisibility = true))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Create gateway")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["columns", "data-source", "loading", "expanded-row-keys"]),
    _createVNode(_component_create_gateway_modal, {
      isVisible: _ctx.createGatewayModalVisibility,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createGatewayModalVisibility = false)),
      onSuccess: _ctx.gatewayCreated
    }, null, 8, ["isVisible", "onSuccess"])
  ], 64))
}